import { getByIndex as e } from "../../utils/array/index.js";
import { Vector3toV3 as x } from "../index10.js";
const f = [0, 1, 2];
function p(t, c = 1) {
  const i = e(f, c + 1), o = e(f, c + 2);
  let r = 0;
  t = t.map(x);
  for (let s = 0; s < t.length; s++) {
    const n = t[s], m = e(t, s + 1);
    r += (m[i] - n[i]) * (m[o] + n[o]);
  }
  return r > 0;
}
export {
  p as isPolygonClockwise
};
//# sourceMappingURL=index.js.map
